<script lang="ts" setup>
import { cn } from '@/lib/utils'
import { Plus } from 'lucide-vue-next'
import { HTMLAttributes, inject } from 'vue'
import { Button } from '../button'

const props = defineProps<{
    class?: HTMLAttributes['class']
}>()

const emit = defineEmits<{
    (e: 'increment'): void
}>()

const max = inject<number>('max')
const counter = inject<number>('counter')
</script>

<template>
    <Button
        v-bind="$attrs"
        type="button"
        :disabled="max === counter"
        size="icon"
        variant="outline"
        :class="cn('', props.class)"
        @click="emit('increment')"
    >
        <Plus class="size-4" />
    </Button>
</template>
